import {makeGetOpinionsList} from 'main/factories/usecases/private/my-hospitalization/get-opinions-list-factory';
import {OPINION_CARDS_MOCK} from './mock';

export const getOpinionsList = async (signal: AbortSignal) => makeGetOpinionsList().get({signal});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getOpinionsListMock = async (signal: AbortSignal) => ({content: OPINION_CARDS_MOCK});
